import React, { useState, useMemo, useEffect } from "react"
import { useGeneralData } from "../hooks/useGeneralData"
import { Button, Autocomplete, TextField } from '@mui/material'
import styles from './ModifyRanking.module.scss'
  
export default function ModifyRanking () {
    const {datasetsInfo, datasets, updateRanking} = useGeneralData()
    const [dataset, setDataset] = useState(null)
    const [column, setColumn] = useState(null)
    const [industry, setIndustry] = useState(null)
    const [subIndustry, setSubIndustry] = useState(null)
    const [newRank, setNewRank] = useState(0)

    const [currentDatasetColumns, setCurrentDatasetColumns] = useState('')
    const [currentRankings, setCurrentRankings] = useState('')

    const columnsOptions = useMemo(() => {
        const columns = datasetsInfo?.find(data => data.value === dataset?.value)?.columns
        setCurrentDatasetColumns(columns)
        return columns?.map(column => ({"name": column['name'], "value": column['value']}))
    }, [datasetsInfo, dataset])

    const industrisOptions = useMemo(() => {
        if (currentDatasetColumns) {
            let rankings = currentDatasetColumns.find(data => data.value === column?.value)?.ranking
            setCurrentRankings(rankings)
            return rankings && Object.keys(rankings).map(industry => ({"name": industry, "value": industry}))
        }
    }, [column, currentDatasetColumns])

    const subIndustrisOptions = useMemo(() =>
        industry && Object.keys(currentRankings[industry.name]).map(subIndustry => ({"name": subIndustry, "value": subIndustry}))
    , [industry, currentRankings])

    useEffect(() => {subIndustry && setNewRank(currentRankings[industry.name][subIndustry.name]);return () => {}}, [subIndustry, currentRankings, industry])

    const renderTags = (option, value) => option.value === value.value
    const getOptionLabel = (option) => option.name
    const renderInput = (params, label) => (<TextField {...params} label={`choose ${label}`} variant="outlined" />)

    const chooseDataset = (e, value) => setDataset(value)
    const chooseColumn = (e, value) => setColumn(value)
    const chooseIndustry = (e, value) => setIndustry(value)
    const chooseSubIndustry = (e, value) => setSubIndustry(value)
    const updateNewRank = (e) => setNewRank(Number(e.currentTarget.value))

    const updateNewRanking = () => {
        updateRanking(dataset.value, column.value, industry.value, subIndustry.value, newRank)
        setDataset(null)
        setColumn(null)
        setIndustry(null)
        setSubIndustry(null)
    }

  return (
    <>
        <div className={styles['autocompletes-container']}>
            <Autocomplete
                id="datasets-autocomplete"
                options={datasets || []}
                getOptionLabel={getOptionLabel}
                style={{ width: 300 }}
                renderInput={(params) => renderInput(params, 'dataset')}
                value={dataset}
                onChange={chooseDataset}
                loading={!!datasets}
                renderTags={renderTags}
                disabled={!!column}
            />
            {dataset && <Autocomplete
                id="column-autocomplete"
                options={columnsOptions || []}
                getOptionLabel={getOptionLabel}
                style={{ width: 300 }}
                renderInput={(params) => renderInput(params, 'column')}
                value={column}
                onChange={chooseColumn}
                loading={!!columnsOptions}
                renderTags={renderTags}
                disabled={!!industry}
            />}
            {column && <Autocomplete
                id="industry-autocomplete"
                options={industrisOptions || []}
                getOptionLabel={getOptionLabel}
                style={{ width: 300 }}
                renderInput={(params) => renderInput(params, 'industry')}
                value={industry}
                onChange={chooseIndustry}
                loading={!!industrisOptions}
                renderTags={renderTags}
                disabled={!!subIndustry}
            />}
            {industry && <Autocomplete
                id="subIndustry-autocomplete"
                options={subIndustrisOptions || []}
                getOptionLabel={getOptionLabel}
                style={{ width: 300 }}
                renderInput={(params) => renderInput(params, 'sub industry')}
                value={subIndustry}
                onChange={chooseSubIndustry}
                loading={!!subIndustrisOptions}
                renderTags={renderTags}
            />}
        </div>
        {subIndustry && <input type='number' value={newRank} onChange={updateNewRank}/>}
        {subIndustry && <Button variant="contained" color="primary" onClick={updateNewRanking}> Save </Button>}
    </>
  )
}
